var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { runtime } from '../../runtime/Runtime';
import { bound } from '../../../utils/decorators/basic';
export class AppAds {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get allAdElements() {
        return Array.prototype.slice.call(document.getElementsByClassName('adsbygoogle'));
    }
    get emptyAdElements() {
        return this.allAdElements.filter(el => !el.classList.contains('filled'));
    }
    fillGoogleAds() {
        runtime.runtimeScheduler.scheduleIdleBackgroundTask(this.fillGoogleAdsWhenIdle);
    }
    fillGoogleAdsWhenIdle() {
        this.emptyAdElements.forEach(el => {
            if (!el.classList.contains('filled')) {
                try {
                    window.adsbygoogle.push({});
                }
                catch (e) { }
                el.classList.add('filled');
            }
        });
    }
}
__decorate([
    bound
], AppAds.prototype, "fillGoogleAds", null);
__decorate([
    bound
], AppAds.prototype, "fillGoogleAdsWhenIdle", null);
